import axios from "axios";
import { BASE_API_URL, getAPIHeaderOptions } from "../../utils/apiUtils";
import { ILoginRequestData, ILoginUserDetails } from "../../interfaces";

const handleLoginUser = (requestData: ILoginRequestData): Promise<ILoginUserDetails> => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${BASE_API_URL}/auth/login`, requestData, { headers: getAPIHeaderOptions() })
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				let errorMessage = "Something went wrong";

				if (error && error.response && error.response.data) {
					const errorValue = Object.values(error.response.data)[0];
					errorMessage = errorValue ? String(errorValue) : "Something went wrong";
				}

				reject(errorMessage);
			});
	});
};

const handleLogoutUser = (): Promise<void> => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${BASE_API_URL}/auth/logout`, { headers: getAPIHeaderOptions(true) })
			.then(() => {
				resolve();
			})
			.catch((error) => {
				reject(error?.response?.data?.detail);
			});
	});
};

const authServices = { handleLoginUser, handleLogoutUser };

export default authServices;
